<div class="cart-overlay">
  <div class="cart-container">
    <!-- Main Cart View -->
    <div class="cart-view" [class.hidden]="currentView !== 'cart'">
      <div class="cart-header">
        <button class="back-button" (click)="close()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <div class="restaurant-info">
          <span class="restaurant-name">{{storeName}} Cart</span>
          <span class="restaurant-location" (click)="showAddressScreen()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px"
              style="vertical-align: middle; margin-right: 4px;">
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-.83 0-1.5-.67-1.5-1.5S11.17 8.5 12 8.5s1.5.67 1.5 1.5S12.83 11.5 12 11.5z" />
            </svg>
            {{ selectedLocation }}
          </span>
        </div>
        <!-- <button class="more-options">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path
              d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
        </button> -->
      </div>

      <div class="cart-content" [formGroup]="cartFormGroup">
        <!-- Main Order Item Section -->
        <div class="main-order-item-section" formArrayName="salesFlatQuoteItem">
          <div class="submainOrderitemSection" *ngFor="let item of cartItemsList.controls; let i = index"
            [formGroupName]="i">
            <div class="item-details">
              <span class="veg-icon" [class.non-veg]="!mainItem.isVeg"></span>
              <div class="item-name">{{ item.get('name')?.value }}</div>
              <div class="item-description">{{ item.get('description')?.value }}</div>
            </div>
            <div class="item-controls">
              <button class="quantity-button" (click)="decrementass(item?.controls?.qty?.value,i)"
                [disabled]='item?.controls?.qty?.value <= 1 || disableControl==0'>-</button>
              <span class="quantity">{{ item.get('qty')?.value }}</span>
              <button class="quantity-button" (click)="increment(item?.controls?.qty?.value,'all',i)">+</button>
            </div>
            <div class="item-price">{{ item.get('price')?.value | currency:'INR' }}</div>
          </div>
          <!-- <div class="submainOrderitemSection">
            <div class="item-details">
              <span class="veg-icon" [class.non-veg]="!mainItem.isVeg"></span>
              <div class="item-name">{{ mainItem.name }}</div>
              <div class="item-description">{{ mainItem.description }}</div>
            </div>
            <div class="item-controls">
              <button class="quantity-button" (click)="updateMainItemQuantity(-1)">-</button>
              <span class="quantity">{{ mainItem.quantity }}</span>
              <button class="quantity-button" (click)="updateMainItemQuantity(1)">+</button>
            </div>
            <div class="item-price">₹{{ mainItem.price }}</div>
          </div> -->

        </div>

        <div class="additional-options">
          <button class="add-items-button" (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            Add Items
          </button>
          <button class="cooking-requests-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" />
            </svg>
            Cooking requests
          </button>
          <!-- <label class="checkbox-container">
            <input type="checkbox">
            <span class="checkbox-checkmark"></span>
            Cutlery
          </label> -->
        </div>

        <!-- Complete Your Meal Section (Carousel) -->
        <div class="complete-meal-section">
          <div class="section-title">COMPLETE YOUR MEAL</div>
          <div class="category-tabs">
            <button *ngFor="let category of mealCategories" [class.active]="selectedCategory === category.id"
              (click)="selectCategory(category.id)">
              {{ category.name }}
            </button>
          </div>
          <div class="meal-items-carousel">
            <div *ngFor="let item of getCategoryItems()" class="meal-item-card">
              <div class="item-image-container">
                <img [src]="item.imageUrl" alt="{{ item.name }}" class="item-image">
                <button class="add-to-cart-button" (click)="addToCart(item)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px"
                    height="16px">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                  </svg>
                </button>
              </div>
              <div class="item-info">
                <span class="veg-icon" *ngIf="item.isVeg"></span>
                <span class="veg-icon non-veg" *ngIf="!item.isVeg"></span>
                <div class="item-name">{{ item.name }}</div>
                <div class="item-description">{{ item.description }}</div>
                <div class="item-price">₹{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="delivery-options-section">
          <div class="section-title">Delivering superfast!</div>
          <div class="option-card">
            <label class="radio-container">
              <input type="radio" name="deliveryType" value="standard" checked>
              <span class="checkmark"></span>
              <div class="option-details">
                <div class="option-name">Standard</div>
                <div class="option-description">Minimal order grouping</div>
              </div>
            </label>
            <div class="option-time">20-25 mins</div>
          </div>
          <div class="option-card">
            <label class="radio-container">
              <input type="radio" name="deliveryType" value="eco-saver">
              <span class="checkmark"></span>
              <div class="option-details">
                <div class="option-name">Eco Saver</div>
                <div class="option-description">Lesser CO2 by order grouping</div>
              </div>
            </label>
            <div class="option-time">25-30 mins</div>
          </div>
        </div>

        <div class="savings-corner">
          <div class="coupon-row" (click)="showCouponScreen()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8h16v10zm-5-9H9v2h6V9z" />
            </svg>
            <span>Apply Coupon</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
            </svg>
          </div>
        </div>

        <div class="bill-details-section">
          <div class="to-pay-summary">
            <div class="to-pay-header">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px"
                height="20px">
                <path
                  d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
              </svg>
              <span>To Pay {{ grandTotalWithoutShippingCharge - (discountAmt ? discountAmt : 0) | currencyConvert }}
              </span>
            </div>
            <button class="toggle-details-button" (click)="toggleBillDetails()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px"
                height="20px">
                <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
              </svg>
            </button>
          </div>

          <div class="bill-items" [class.collapsed]="!isBillDetailsExpanded">
            <div class="bill-item">
              <span>Item Total</span>
              <span>{{ grandTotalWithoutShippingCharge-taxAmount
                |currencyConvert }} </span>
            </div>
            <div class="bill-item">
              <span>Delivery Fee | {{ deliveryDistance }} kms</span>
              <span>{{delieveryCharge
                |currencyConvert }}</span>
            </div>
            <div class="delivery-info-text">
              This fee fairly goes to our delivery partners for delivering your food
            </div>
            <div class="bill-item">
              <span>Delivery Tip</span>
              <span class="add-tip-text">Add tip</span>
            </div>
            <div class="bill-item">
              <span>GST & Other Charges</span>
              <span> {{taxAmount |currencyConvert }}</span>
            </div>
            <div class="bill-item" *ngIf="discountAmt">
              <span>Discount Amount</span>
              <span style="color: rgb(67, 206, 67);"> {{ discountAmt |currencyConvert }}</span>
            </div>
            <div class="bill-item total-line">
              <span>To Pay</span>
              <span>{{ grandTotalWithoutShippingCharge - (discountAmt ? discountAmt : 0) | currencyConvert }}
              </span>
            </div>
          </div>
        </div>

        <div class="cancellation-policy">
          <p><strong>Cancellation policy:</strong></p>
          <p>Please double-check your order and address details. Orders are non-refundable once placed.</p>
        </div>
      </div>

      <div class="cart-footer">
        <div class="pay-using" (click)="showPaymentScreen()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px">
            <path
              d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V8h16v10z" />
          </svg>
          <span>PAY USING</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
          </svg>
          <div class="payment-method">
            <span>{{selectedPaymentOptionName == "COD" ? "Cash on Delivery" : selectedPaymentOptionName }}</span>
          </div>
        </div>
        <button class="pay-button" (click)="finalPay()">Pay {{ grandTotalWithoutShippingCharge - (discountAmt ?
          discountAmt : 0) | currencyConvert }}
        </button>
      </div>
    </div>

    <!-- Coupon Screen View -->
    <div class="coupon-view" [class.hidden]="currentView !== 'coupon'">
      <div class="coupon-header">
        <button class="back-button" (click)="hideCouponScreen()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <div class="header-title">APPLY COUPON</div>
      </div>
      <div class="coupon-content">
        <div class="cart-value-info">Your cart:{{ grandTotalWithoutShippingCharge
          |currencyConvert }}</div>
        <div class="coupon-input-section">
          <input type="text" placeholder="Enter Coupon Code" class="coupon-input" [(ngModel)]="searchTerm">
          <button class="apply-coupon-button" (click)="applySearchedCoupon()">APPLY</button>

        </div>

        <div class="more-offers-section">

          <div *ngFor="let offer of couponList" class="offer-card" [class.selected]="offer.name === selectedCouponName">
            <div class="offer-sidebar">
              <span class="sidebar-text">CASHBACK</span>
            </div>
            <div class="offer-details">
              <div class="offer-header">
                <img [src]="offer.iconUrl" alt="{{ offer.name }} icon" class="offer-icon">
                <span class="offer-name">{{ offer.name }}</span>
                <button class="apply-offer-button" [class.selected]="offer.name === selectedCouponName"
                  (click)="applyCoupon(offer.name,offer.salesRuleCoupon[0].code)">{{ offer.name === selectedCouponName ?
                  'APPLIED' : 'APPLY' }}</button>
              </div>
              <!-- <div class="offer-description">{{ offer.description }}</div> -->
              <div class="offer-terms">{{ offer.description }}</div>
              <!-- <button class="more-button">+ MORE</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Options Screen View -->
    <div class="payment-view" [class.hidden]="currentView !== 'payment'">
      <div class="payment-header">
        <button class="back-button" (click)="hidePaymentScreen()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>
        <div class="header-title">Payment Options</div>
      </div>
      <div class="payment-content">
        <div class="payment-summary">
          <span>{{ cartItemsList.controls.length }} Item</span>
          <span>Total: {{ grandTotalWithoutShippingCharge - (discountAmt ?
          discountAmt : 0) | currencyConvert }}</span>
        </div>

        <div class="payment-section">
          <div class="section-title">UPI</div>
          <div *ngFor="let upiOption of upiOptions" class="payment-option-card">
            <img *ngIf="upiOption.iconUrl" [src]="upiOption.iconUrl" alt="{{ upiOption.name }} icon"
              class="option-icon">
            <svg *ngIf="upiOption.iconPath" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              width="24px" height="24px" class="option-icon">
              <path [attr.d]="upiOption.iconPath"></path>
            </svg>
            <div class="option-details">
              <div class="option-name">{{ upiOption.name }} <span *ngIf="upiOption.tag" class="option-tag">{{
                  upiOption.tag }}</span></div>
              <div class="option-description">{{ upiOption.description }}</div>
            </div>
            <label class="radio-container" *ngIf="upiOption.radio">
              <input type="radio" name="paymentUpi" [value]="upiOption.id" [(ngModel)]="selectedPaymentOption"
                (change)="onUpiOptionSelected(upiOption)">
              <span class="checkmark" [class.checked]="selectedPaymentOption === upiOption.id"></span>
            </label>
            <svg *ngIf="upiOption.arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              width="20px" height="20px">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
            </svg>
            <button *ngIf="upiOption.expandable" class="expand-button">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px"
                height="20px">
                <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
              </svg>
              View all UPI options
            </button>
          </div>
        </div>
        <div class="payment-section">
          <div class="section-title">Door Delivery</div>
          <div class="payment-option-card add-card-option" [class.active]="selectedPaymentOptionName === 'COD'"
            style="gap: 10px;" (click)="selectCashOnDelivery()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#4CAF50" height="24" width="24" viewBox="0 0 24 24">
              <path
                d="M20 8h-3V4H3v13h2a3 3 0 1 0 6 0h4a3 3 0 1 0 6 0h1v-5l-4-4zm-3 1.5l2.5 2.5H17v-2.5zM7 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
            </svg>

            <div class="option-details">
              <div class="option-name">Cash On Delivery</div>
              <div class="option-description">Pay in cash when your order is delivered to your doorstep.</div>
            </div>
          </div>
        </div>


        <div class="payment-section">
          <div class="section-title">Credit & Debit Cards</div>
          <div class="payment-option-card add-card-option">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
            <div class="option-details">
              <div class="option-name">Add New Card</div>
              <div class="option-description">Save and Pay via Cards.</div>
            </div>
          </div>

        </div>
        <div class="payment-section" *ngIf="qrCodePaymentMode">
          <div class="section-title">QR Code Scanner</div>
          <div fxLayout="column" fxFlex="100">

            <div fxLayout="row" fxFlex>

              To continue with your order
            </div>
            <br>
            <div fxLayout="row" fxFlex>
              1. Please open your UPI Payment App
            </div>
            <br>
            <div fxLayout="row" fxFlex>
              2. Scan the below QR Code.
            </div>
            <br>
            <div fxLayout="row" fxFlex>
              3. Pay &nbsp;<b>{{partialPaymentControl.value=='Partial Payment'&&paritialPaymentEnabled==1?
                paritialPaymentAmountControl.value:grandTotal+consultationFees |currencyConvert}} &nbsp;</b>
              and
              complete payment.
            </div>
            <br>
            <div fxLayout="row" fxFlex>
              4. After successful completion, Please enter last 4 digits of Transaction ID in the text field
              below.
            </div>
            <br>
            <div fxLayout="row" fxFlex>
              5. Our team will send you order confirmation details over Whatsapp (or) Email within 30 minutes
              of
              successful verification.
            </div>


            <br>

            <div fxLayout="row">
              <p>Scan the QrCode</p>
            </div>

            <div fxLayout="row">
              <!-- <img style="height:80px;
                      width: auto;" [src]="serverPath1+paymentOption.qrcodeImage" onerror="this.src='assets/images/products/noImage/no-image.png';
                          " alt=""> -->
              <img style="height: min-content;
                          width: min-content;" [src]="imageURL" width="500px" height="500px">
            </div>

            <br>
            <div fxLayout="row">
              &nbsp; &nbsp; &nbsp; &nbsp; OR
            </div>
            <br>


            <br>
            <div fxLayout="row">


              Pay with Upi Id given below :

            </div>
            <br>

            <div fxLayout="row">

              <div fxFlex="15" class="couponCode">
                <div style=" min-width: max-content;" (click)="copyInputMessage(qrCodePaymentMode.upiId)" fxLayout="row"
                  mat-elevation-z6 fxLayoutAlign="center center">
                  {{qrCodePaymentMode.upiId}}
                </div>
              </div>

            </div>
            <div fxLayout="row">
              <p>Once Done Please Share the Last four digits of Transaction Id</p>
            </div>
            <div fxLayout="row">
              <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Transaction Number</mat-label>
                <input (keypress)="numberOnly($event)" trim="blur" [formControl]="qrCodeReference" matInput required>
                <mat-error *ngFor="let validation of commentValidations.qrCodeReference">
                  <mat-error class="error-message"
                    *ngIf="this.qrCodeReference.hasError(validation.type) && (this.qrCodeReference.dirty || this.qrCodeReference.touched) ">
                    {{validation.message}}
                  </mat-error>
                </mat-error>

              </mat-form-field>
            </div>

            <!-- <div fxLayout="row"  fxFlex="100">
                            <div class="padding-15"  fxFlex="100" fxLayout="column"   >
                            <button fxLayoutGap="5px"  (click)="paymentResponceQrScan()" style="color:white"  mat-flat-button class="primary">Place Order</button>
                          </div>
                          </div> -->

            <div class="padding-10">

              <button fxLayoutAlign="start center" [disabled]="btnLabeltxt !='CONFIRM ORDER'" fxLayoutGap="5px"
                (click)="paymentResponceQrScan()" style="color:white" class="primary" mat-flat-button>
                {{btnLabeltxt}}
                <mat-icon *ngIf="btnLabeltxt !='CONFIRM ORDER' ">
                  <mat-spinner color="primary" diameter="20">
                  </mat-spinner>
                </mat-icon>
              </button>

              <!-- <button fxLayoutAlign="start center" fxLayoutGap="5px" (click)="paymentResponceQrScan()"
                        style="color:white" class="primary" mat-flat-button>{{btnLabeltxt}}</button> -->
            </div>

          </div>

        </div>

        <div class="payment-section">
          <div class="section-title">More Payment Options</div>
          <div *ngFor="let moreOption of morePaymentOptions" class="payment-option-card">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px"
              class="option-icon">
              <path [attr.d]="moreOption.iconPath"></path>
            </svg>
            <div class="option-details">
              <div class="option-name">{{ moreOption.name }}</div>
              <div class="option-description">{{ moreOption.description }}</div>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px" height="20px">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Address Selection Screen View -->
    <div class="address-view" [class.hidden]="currentView !== 'address'" [formGroup]="firstFormGroup">

      <div class="address-header">
        <button class="close-button" (click)="hideAddressScreen()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
        <div class="header-title">Choose a delivery address</div>
      </div>
      <div class="address-content">
        <div class="add-new-address-card" (click)="addAddress(getAddressCount())">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          <span>Add new Address</span>
        </div>

        <div class="saved-addresses-list">
          <div *ngFor="let address of  firstFormGroup?.controls?.address['controls'];let i =index " class="address-card"
            (click)="selectAddress(address,i)">
            <div class="address-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px"
                height="24px">
                <path [attr.d]="'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'"></path>
              </svg>
            </div>
            <div class="address-details">
              <div class="address-type">
                {{ address.controls.addressType.value || 'Home' }}
                <span class="selected-tag" *ngIf="i === selectedIndex">SELECTED</span>
              </div>

              <div class="address-full">
                {{ address.controls.street.value }}, {{ address.controls.city.value }}<br>
                {{ address.controls.state.value }} - {{ address.controls.postCode.value }}
              </div>

              <div class="address-description">
                {{ address.controls.street.value }}
              </div>
            </div>

            <div class="address-arrow" *ngIf="selectedAddressId !== address.id">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20px"
                height="20px">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>